var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-shortcuts"},_vm._l((_vm.shortcuts),function(shortcut){return _c('span',{key:shortcut.label,staticClass:"shortcut",class:{ 'active': (_vm.current) ? _vm.current.label == shortcut.label : false },on:{"click":function($event){return _vm.select(shortcut)}}},[_vm._v(" "+_vm._s(shortcut.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }